
    import { mixins, Component } from 'nuxt-property-decorator';
    import accordionMixin from '@/mixins/accordionMixin';

    @Component
    export default class Accordion extends mixins(accordionMixin) {}
